export function normalizeRouteSlugParam(slugParam?: string | string[]): string {
  if (!slugParam) return ''

  if (Array.isArray(slugParam)) {
    return slugParam.filter(Boolean).join('/').replace(/^\/+|\/+$/g, '')
  }

  return slugParam.replace(/^\/+|\/+$/g, '')
}

export function toCmsUri(slug: string): string {
  return slug || '__home__'
}
